"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCashflowTypeText = exports.formatCashflow = void 0;
const component_1 = require("./../component");
const interface_1 = require("./../interface");
function formatCashflow(data) {
    const { coins } = data, value = __rest(data, ["coins"]);
    const { amount = "", coin } = (coins === null || coins === void 0 ? void 0 : coins[0]) || {};
    return Object.assign(Object.assign({}, value), { coin: component_1.CalculateUtils.getDisplayCurrency(coin), amount });
}
exports.formatCashflow = formatCashflow;
function getCashflowTypeText(cashflow) {
    const { cashflow_type, sub_type } = cashflow;
    if (!!sub_type) {
        switch (sub_type) {
            case interface_1.FuturesCashflowSubType.ACCOUNT_IN:
            case interface_1.FuturesCashflowSubType.ACCOUNT_OUT:
            case interface_1.FuturesCashflowSubType.STRATEGY_IN:
            case interface_1.FuturesCashflowSubType.STRATEGY_OUT:
                return "transfer";
            case interface_1.FuturesCashflowSubType.DELISTING:
                return "cashflow_delisting";
            case interface_1.FuturesCashflowSubType.ISO_AUTO_IN:
                return "cashflow_iso_auto_in";
            case interface_1.FuturesCashflowSubType.ISO_AUTO_OUT:
                return "cashflow_iso_auto_out";
            case interface_1.FuturesCashflowSubType.ISO_MANUAL_IN:
                return "cashflow_iso_manual_in";
            case interface_1.FuturesCashflowSubType.ISO_MANUAL_OUT:
                return "cashflow_iso_manual_out";
            case interface_1.FuturesCashflowSubType.TRADING:
                return "account_trading_fee";
        }
    }
    switch (cashflow_type) {
        case interface_1.FuturesCashflowType.FUNDING_FEE:
            return "funding_fee";
        case interface_1.FuturesCashflowType.LIQUIDATION_FEE:
            return "cashflow_liquidation_fee";
        case interface_1.FuturesCashflowType.MARGIN_SWAP:
            return "margin_swap";
        case interface_1.FuturesCashflowType.POSITION_SETTLEMENT:
            return "position_settlement";
        case interface_1.FuturesCashflowType.REMEDY:
            return "remedy";
        case interface_1.FuturesCashflowType.TRADING_FEE:
            return "account_trading_fee";
        case interface_1.FuturesCashflowType.TRANSFER:
            return "transfer";
        case interface_1.FuturesCashflowType.TRIAL_FUND:
            return "futures_trial_fund";
    }
}
exports.getCashflowTypeText = getCashflowTypeText;
